import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CHART_CARD_SURFACE, getBoardChartCardClass, isBoardChartCardSurface } from './chartCard.js';
import StatisticsChartCardHeader from './StatisticsChartCardHeader';
import StatisticsChartCardResizeHandle from './StatisticsChartCardResizeHandle';

const StatisticsChartCard = ({
	surface = CHART_CARD_SURFACE.PRESET,
	variant,
	className,
	isDragging = false,
	isDragTarget = false,
	isMapPreview = false,
	title,
	onFullscreen,
	meta,
	toolbar,
	headMainProps,
	plotBodyClassName,
	plotBodyStyle,
	children,
	canResizeWidth = false,
	onResizePointerDown,
}) => {
	const boardClass = getBoardChartCardClass(surface);
	const isBoard = isBoardChartCardSurface(surface);
	const hasPlotBody = surface === CHART_CARD_SURFACE.PRESET && Boolean(plotBodyClassName || plotBodyStyle);

	if (isBoard && boardClass) {
		const body = boardClass.body ? <div className={boardClass.body}>{children}</div> : children;

		return (
			<article
				className={classNames(
					boardClass.root,
					className,
					boardClass.rootMap && isMapPreview && boardClass.rootMap,
					{
						'is-dragging-source': isDragging,
						'is-drag-target': isDragTarget,
					},
				)}
			>
				<StatisticsChartCardHeader surface={surface} meta={meta} toolbar={toolbar} headMainProps={headMainProps} title={title} onFullscreen={onFullscreen} />
				{body}
				<StatisticsChartCardResizeHandle surface={surface} canResizeWidth={canResizeWidth} onResizePointerDown={onResizePointerDown} />
			</article>
		);
	}

	return (
		<section className={classNames(`statistics-pipeline-page__chart statistics-pipeline-page__chart--${variant}`, className)}>
			<StatisticsChartCardHeader surface={surface} meta={meta} toolbar={toolbar} headMainProps={headMainProps} title={title} onFullscreen={onFullscreen} />
			{hasPlotBody ? (
				<div className={['statistics-pipeline-page__chart-plot-body', plotBodyClassName].filter(Boolean).join(' ')} style={plotBodyStyle ?? undefined}>
					{children}
				</div>
			) : (
				children
			)}
		</section>
	);
};

StatisticsChartCard.propTypes = {
	surface: PropTypes.oneOf(Object.values(CHART_CARD_SURFACE)),
	variant: PropTypes.string,
	className: PropTypes.string,
	isDragging: PropTypes.bool,
	isDragTarget: PropTypes.bool,
	isMapPreview: PropTypes.bool,
	title: PropTypes.string,
	onFullscreen: PropTypes.func,
	meta: PropTypes.node,
	toolbar: PropTypes.node,
	headMainProps: PropTypes.object,
	plotBodyClassName: PropTypes.string,
	plotBodyStyle: PropTypes.object,
	children: PropTypes.node,
	canResizeWidth: PropTypes.bool,
	onResizePointerDown: PropTypes.func,
};

export default StatisticsChartCard;
